import { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button } from "primereact/button"

import styles from "../../../../styles/TwoFA.module.css"

import { getAuth } from "firebase/auth"
import { LogDebug, LogError } from "../../../../helpers/logger"
import { useAuth } from "../../../../context/authContext"
import { UserContext } from "../../../../context/userContext"

export default function EmailVerification({ emailVerified, reloadUser }) {
  const [checkingVerification, setCheckingVerification] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [msg, setMsg] = useState("")
  const [loading, setLoading] = useState(false)
  const { sendEmailVerificationNotification } = useAuth()
  const { tokens } = useContext(UserContext)

  const user = getAuth().currentUser

  // Polling for email verification every 5 seconds
  useEffect(() => {
    let interval
    if (checkingVerification) {
      interval = setInterval(async () => {
        LogDebug("Polling on email verification")
        await reloadUser()
      }, 5000)
    }
    return () => clearInterval(interval)
  }, [checkingVerification, reloadUser])

  // Stop polling when user.emailVerified updates
  useEffect(() => {
    if (emailVerified && checkingVerification) {
      LogDebug("Email verification detected. Stopping polling.")
      setCheckingVerification(false)
    }
  }, [checkingVerification, emailVerified])

  async function handleEmailVerification() {
    // const auth = getAuth()
    setLoading(true)
    try {
      const authToken = tokens?.getMainToken?.()
      await sendEmailVerificationNotification(authToken)
      setEmailSent(true)
      setCheckingVerification(true)
    } catch (error) {
      setMsg(error.message)
      LogError("Error sending email verification", error)
    } finally {
      setLoading(false)
    }
  }

  function checkEmailVerification() {
    if (emailVerified) {
      return (
        <div className={styles.block}>
          ✅ Your email <strong>{user.email}</strong> is verified. You can now
          enable 2FA.
        </div>
      )
    }
    return (
      <div className={styles.block}>
        {emailSent ? (
          <div className={styles.marginTop10}>
            We sent a verification email to <strong>{user.email}</strong>.
            Please check your inbox and spam folder, then click the verification
            link to continue.
          </div>
        ) : (
          <>
            <div>
              Your email <strong>{user.email}</strong> is not verified. Please
              verify your email first.
            </div>
            <Button
              label="Click here to verify your email"
              onClick={() => handleEmailVerification()}
              loading={loading}
              disabled={loading}
              className={styles.marginTop15}
            />
          </>
        )}
      </div>
    )
  }

  return (
    <div className={styles.block}>
      <h2>Step 1: Email Verification</h2>
      {msg !== "" && <div>{msg}</div>}
      {checkEmailVerification()}
    </div>
  )
}

EmailVerification.propTypes = {
  // user: PropTypes.shape({
  //   email: PropTypes.string.isRequired,
  //   emailVerified: PropTypes.bool.isRequired,
  // }).isRequired,
  reloadUser: PropTypes.func.isRequired,
}
